module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-11-0774886d18960dae8d1856c58b354cf2.svg";